import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	font-family: "Mulish";
`;

export const Content = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	overflow: auto;

	.content-wrapper {
		display: flex;
		flex-direction: column;

		background-color: white;

		padding: 1rem;

		height: 100%;
		width: 100%;
	}
	.header-wrapper {
		display: flex;
		flex-direction: column;

		gap: 1.5rem;

		border-bottom: 1px solid #c4c4c4;
	}
	.header {
		display: flex;
		flex-direction: column;

		gap: 0.5rem;
	}
	.txt-header {
		text-transform: uppercase;
		font-weight: bold;
		font-size: 1.6rem;
		color: #2d7bbc;
	}
	.docs-wrapper {
		display: flex;

		gap: 2rem;

		padding: 0 0 1rem 1rem;

		overflow-x: auto;
		margin-bottom: 1rem;
	}
	.doc {
		display: flex;

		align-items: center;

		gap: 1rem;
		padding: 1rem;

		border-radius: 1rem;

		height: 4rem;

		color: #2d7bbc;

		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
		background-color: #f3f3f3;

		cursor: pointer;
		p {
			white-space: nowrap;
		}
		div {
			width: 2rem;
			height: 2rem;

			background-color: white;
			border-radius: 50%;
		}
		:hover {
			color: white;
			background-color: rgba(55, 81, 255, 0.75);
			div {
				background-color: white;
			}
		}
	}

	.selected {
		color: white;
		background-color: rgba(55, 81, 255, 0.75);
		div {
			background-color: white;
		}
	}
	.quest-wrapper {
		display: flex;
		flex-direction: column;

		overflow: auto;
		padding: 1rem 1rem 0 0;

		width: 100%;
		height: 90%;
	}
	.no-question-available {
		display: flex;
		width: 100%;
		height: 100%;

		align-items: center;
		justify-content: center;

		#no-question-text {
		font-size: 1.5rem;
		font-family: "mulish";
		
		color: #2d7bbc;
		text-transform: uppercase;
		}
	}

	.doc-side {
		display: block;

		position: relative;

		width: 100%;
		height: 100%;

		background-color: #ececec;

		align-items: center;
		justify-content: center;

		iframe {
			height: 100%;
			width: 100%;
		}
	}
	.button-wrapper {
		display: flex;

		height: 5rem;
		width: 100%;

		gap: 2rem;

		padding: 1rem 0;

		justify-content: center;
		align-items: center;

		button {
			padding: 1rem;

			border: none;
			border-radius: 0.25rem;

			font-size: 1.2rem;
			font-weight: 600;

			cursor: pointer;

			text-transform: uppercase;

			color: white;
			background-color: #2d7bbc;
		}

		#cancel-button {
			background-color: white;
			color: #2d7bbc;
			border: 1px solid #2d7bbc;
			transition: 0.25s;

			:hover {
				color: red;
				border-color: red;
			}
		}

		#button-no-response {
			background-color: #96bddd;
		}

		#button-no-response::after {
			content: "Visualize questões não respondidas";
			position: absolute;
			font-size: 8pt;
			color: red;
			cursor: pointer;
		}
	}
`;

export const ContentMessage = styled.div`
	flex-direction: row;
	width: 25rem;
	min-width: 16rem;
	max-height: 40rem;
	padding: 1rem;
	background: #e9e7f4;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 0.5rem;

	overflow-y: auto;

	font-family: "Roboto";

	> div {
		display: flex;
		flex-direction: row;

		margin: 1rem;
	}

	h4 {
		margin: 1rem;
		font-size: 16pt;
		text-align: center;
		color: red;
	}

	h6 {
		text-align: justify;
	}

	span {
		color: red;
		margin-right: 0.5rem;
	}
`;

export const NoDocumentProvided = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	p {
		width: 100%;
		max-width: 400px;
		text-align: center;
	}

	button {
		padding: 1rem;

		border: none;
		border-radius: 0.25rem;

		font-size: 1.2rem;
		font-weight: 600;

		cursor: pointer;

		text-transform: uppercase;

		color: white;
		background-color: #2d7bbc;

		margin-top: 20px;
	}
`;
